import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-label="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I&apos;M{" "}
                <strong className="main-name">Muniraj M</strong>
              </h1>

              <div style={{ padding: "50px 50px 20px" }}>
                <Type />
                <p className="intro-text">
                  I&apos;m <strong>Muniraj</strong>, a passionate full-stack
                  developer specializing in <strong>Laravel</strong>,{" "}
                  <strong>PHP</strong>, and <strong>React.js</strong>. I design
                  and build modern, performant web applications with clean UI
                  and scalable backend systems. Based in India and open to
                  exciting tech opportunities.
                </p>
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="Developer illustration"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
